import gsap from 'gsap';

export const initJobs = () => {
    document.querySelectorAll('.c-jobs').forEach(container => {
        if (container.querySelector('.c-jobs-list.backend')) return;

        const list = container.querySelector('.c-jobs-list');
        const records = container.querySelectorAll('.c-jobs-list > div');
        const pagination = container.querySelector('.c-jobs-pagination');
        const prev = container.querySelector('.c-jobs-pagination .prev');
        const next = container.querySelector('.c-jobs-pagination .next');
        const currentSpan = container.querySelector('.c-jobs-pagination .current');
        const maxSpan = container.querySelector('.c-jobs-pagination .max');

        if (!list || !records || !pagination || !prev || !next || !currentSpan || !maxSpan) return;

        const recordsPerPage = 3;

        if (recordsPerPage < records.length) {
            pagination.classList.remove('hidden');
        } else {
            return;
        }

        const numPages = () => Math.ceil(records.length / recordsPerPage);
        let currentPage = 1;

        prev.addEventListener('click', () => {
            if (currentPage > 1) {
                currentPage--;
                changePage(currentPage);
            }
        });

        next.addEventListener('click', () => {
            if (currentPage < numPages()) {
                currentPage++;
                changePage(currentPage);
            }
        });

        maxSpan.innerHTML = numPages().toString();

        function changePage(page) {
            if (page < 1) page = 1;
            if (page > numPages()) page = numPages();

            let height = 0;
            let counter = 1;
            let elements = 0;

            list.innerHTML = '';

            for (let i = (page - 1) * recordsPerPage; i < page * recordsPerPage && i < records.length; i++) {
                list.appendChild(records[i]);

                height += records[i].scrollHeight;

                // Fade in animation.
                gsap.fromTo(
                    records[i],
                    { autoAlpha: 0, x: '-1rem' },
                    { delay: counter * 0.5, duration: 1, autoAlpha: 1, x: 0 }
                );

                elements++;

                // Reset animation counter.
                counter > recordsPerPage ? (counter = 1) : counter++;
            }

            list.style.setProperty('height', height + 'px');
            list.style.setProperty('transition-duration', elements * 0.5 + 's');
            list.style.setProperty('transition-delay', elements * 0.125 + 's');

            currentSpan.innerHTML = page.toString();

            prev.style.setProperty('opacity', page === 1 ? 0.3 : 1);
            next.style.setProperty('opacity', page === numPages() ? 0.3 : 1);
        }

        changePage(1);
    });
};

export const fixJobsContainerOnResize = () => {
    document.querySelectorAll('.c-jobs').forEach(container => {
        if (container.querySelector('.c-jobs-list.backend')) return;

        const list = container.querySelector('.c-jobs-list');
        const records = container.querySelectorAll('.c-jobs-list > div');

        if (!list || !records) return;

        let height = 0;

        records.forEach(record => (height += record.scrollHeight));

        if (list.scrollHeight !== height) {
            list.style.setProperty('height', height + 'px');
        }
    });
};
